import { shallowEqual, useSelector } from 'react-redux'
const selectoreWidgets = (state) => state.worksheetViewReducer;

export const useWorksheetView = () => {
    const selectedData = useSelector(selectoreWidgets, shallowEqual)
    return selectedData;
}